import { useEffect, useState } from 'react';

export function useDebounced<T>(valeur: T, delai: number): T {
  const [v, setV] = useState(valeur);
  useEffect(() => {
    const t = window.setTimeout(() => setV(valeur), delai);
    return () => window.clearTimeout(t);
  }, [valeur, delai]);
  return v;
}
